module.exports = __webpack_public_path__ + "media/images/lb/785-4c41e38379ba680fc676b0e0bcf9b54b.svg";